import { useMemo } from 'react';
import {
  WellnessMetricDto,
  WellnessCompletionRateDto,
  WellnessFormDto,
} from '@repo/shared/dtos/analytics/WellnessDto';
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { BASE_URLS } from './config';
import { createAnalyticsHook } from './utils';

const useWellnessQuery = createAnalyticsHook({
  baseUrl: BASE_URLS.WELLNESS,
  queryKeyPrefix: 'wellness',
});

export const useWellnessMetrics = (filters?: WellnessFilter) =>
  useWellnessQuery<WellnessMetricDto>('/metrics', filters);

const useFiltersWithoutForm = (filters?: WellnessFilter) =>
  useMemo(() => {
    if (!filters) return filters;
    const { formId: _formId, ...rest } = filters;
    return rest;
  }, [filters]);

export const useWellnessCompletionRate = (filters?: WellnessFilter) =>
  useWellnessQuery<WellnessCompletionRateDto>('/completion-rate', useFiltersWithoutForm(filters));

export const useWellnessForms = (filters?: WellnessFilter) =>
  useWellnessQuery<WellnessFormDto[]>('/forms', useFiltersWithoutForm(filters));
